import { makeStyles } from '@rbx/ui';

const useMarkdownTableStyles = makeStyles()((theme) => ({
  outerContainer: {
    overflowX: 'auto',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    tr: {
      verticalAlign: 'top',
    },
    // table markdown font sizes can vary, but
    // inline code should be consistently slightly smaller across all typographies
    '& .inline-code': {
      fontSize: '0.95em',
    },
    td: {
      ...(theme.palette.mode === 'dark' && {
        color: theme.palette.content.muted,
      }),
      '& [class*="Typography-body1"]': {
        fontSize: '16px',
      },
    },
    '& ul, & ol': {
      marginBottom: 0,
      marginTop: 0,
    },
  },
  image: {
    marginBottom: 0,
  },

  header: {
    backgroundColor: theme.palette.background.media,
  },
}));

export default useMarkdownTableStyles;
